<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\WebsitePrimary\components\VehicleCount\ParagonPrimaryVehicleCount.vue
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<template>
  <div
    v-if="inventoryVehicledetails"
    class="container vehicle-inventory-counts-section vehicle-inventory-slick-section"
  >
    <div class="mb-4 text-center">
      <div class="vehicle-count-title d-md-flex justify-content-center align-items-center">
        <h2 class="mb-md-0 page-sections-title">{{ heading ? heading : "New Inventory" }}</h2>
        <strong v-if="enableCountOnPrimaryControl" class="inventory_total_count ml-md-4">
          <span class="vehicle-total-count">{{ inventoryVehicledetails.totalVehicleCount }}</span>
        </strong>
      </div>

      <a class="no-hover color-black hover-color d-block my-3" href="/inventory/new">
        {{ subHeading ? subHeading : "View All" }}
      </a>
    </div>

    <VSlickCarousel ref="slick" v-bind="LuxurySlickOptions" @beforeChange="handleBeforeChange">
      <template #prevArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'previous';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em class="primaryicon-left-arrow slick-arrow" style="cursor: pointer; z-index: 1"></em>
        </div>
      </template>
      <template #nextArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'next';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em
            class="primaryicon-right-arrow bgcolor-primary _msbi_background_color slick-arrow"
            style="color: #cccccc; cursor: pointer; z-index: 1"
          ></em>
        </div>
      </template>
      <div v-for="(vehicle, index) in inventoryVehicledetails.newModels" :key="index" class="px-5">
        <div class="">
          <div
            v-if="enableCountOnPrimaryControl"
            class="font-weight-bold text-center grey-text _theme_font_bold"
            :class="inventoryCountLabel ? 'ft-20' : 'inventory-vehicle-count'"
          >
            {{ vehicle.count }} <span> {{ inventoryCountLabel }}</span>
          </div>
          <div class="inventory-vehicle-image-section d-flex align-items-center my-2 mx-auto">
            <img
              v-if="useoverrides"
              :src="`${vehicle.vehicles.photoURLs}&angle=01&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&useoverrides=${useoverrides}&type=jpeg`"
              class="img-fluid"
              :width="imageWidth"
              :height="imageHeight"
              :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
            />
            <img
              v-else
              :src="`${vehicle.vehicles.photoURLs}&angle=01&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85}&type=jpeg`"
              class="img-fluid"
              :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
              :width="imageWidth"
              :height="imageHeight"
            />
          </div>
        </div>
        <div class="inventory-vehicle-box-details text-center my-4">
          <div class="my-2 ft-20 font-weight-bold _theme_font_bold">
            {{ vehicle.vehicles.year }} {{ vehicle.vehicles.make }}
            {{ vehicle.vehicles.model }}
          </div>
          <div
            v-if="useSellingPriceOnInventoryControl && vehicle.vehicles.yourPrice && !hidePricing"
            class="my-2 inventory-vehicle-box-msrp ft-14"
          >
            Starting at ${{ getThousandSeperator(vehicle.vehicles.yourPrice) }}
          </div>
          <div
            v-else-if="vehicle.vehicles.msrp && !hidePricing"
            class="my-2 inventory-vehicle-box-msrp ft-14"
          >
            Starting at ${{ getThousandSeperator(vehicle.vehicles.msrp) }}
          </div>
          <div v-else class="my-2 inventory-vehicle-box-msrp ft-14">
            <a v-if="isMobile" class="no-hover" :href="'tel:' + salesnumber">
              <span class="color-black cursor-pointer">Call For Price</span>
            </a>
            <span v-else> Call For Price </span>
          </div>
          <div class="mt-4">
            <a
              :href="`${vehicle.vehicles.url}`"
              class="no-hover bgcolor-primary text-white py-2 px-5 d-inline-block text-uppercase rounded-buttons"
              >View Details</a
            >
          </div>
        </div>
      </div>
    </VSlickCarousel>
  </div>
</template>
<script type="text/javascript">
import VehicleCount from "./VehicleCount";
export default {
  mixins: [VehicleCount],
  data() {
    return {};
  },
};
</script>

<style scoped>
.vehicle-year span {
  background-color: #7f7f7f;
  border-radius: 5px;
}
.img-ht {
  max-height: 90px !important;
  margin: 0 auto;
}

@media (min-width: 1200px) {
  .inventory-vehicle-image-section {
    width: 80%;
  }
}
.inventory-vehicle-count {
  font-size: 5em;
  height: 87px;
}
/* for slick */
.vehicle-inventory-slick-section {
  padding: 0px 28px;
}

.vehicle-inventory-slick-section :deep(.v-slick-arrow:before) {
  color: red;
}
</style>
